import { useEffect } from 'react'
import { getLogger } from 'shared/infrastructure/dataDog'
import {
  isSessionExpired,
  removeSession,
} from '../../infrastructure/storage/auths'

export const useAuthVerify = () => {
  const SET_INTERVAL_TIMER = 180000
  useEffect(() => {
    const timer = setInterval(() => {
      try {
        if (isSessionExpired()) {
          removeSession()
        }
      } catch (error) {
        getLogger().error(error)
        removeSession()
      }
    }, SET_INTERVAL_TIMER)
    return () => clearInterval(timer)
  }, [])
}
